import Direction from "./Direction";
import { ThemeType } from "./theme";

const configs = {
  direction: Direction.RTL,
  setThemeType: (themeType: ThemeType) => {},
};

export default configs;
